export enum FontPack {
  FontAwesomeSolid = 'font-awesome-solid',
  FontAwesomeRegular = 'font-awesome-regular',
}
